export const SHARE_MODAL_EVENTS = {
  RESET_SHAREABLE_LINK: "reset-shareable-link",
  RESET_PASSCODE: "reset-passcode",
  UNSHARE_FROM_USER: "unshare-from-user",
};
